import constants from 'app/shared/constants/ConstantsBundle';
import api from 'app/shared/utils/api';
import type { AppThunkDispatch } from 'app/shared/flux/store/configureStore';

type SubmitReviewParams = {
  listingAlias: string;
  rating: number;
  comment: string;
  reviewType?: string;
};

const ReviewActions = {
  submitReview({ listingAlias, rating, comment, reviewType }: SubmitReviewParams) {
    return function (dispatch: AppThunkDispatch) {
      dispatch({ type: constants.SUBMIT_REVIEW_REQUEST });

      return dispatch(
        api.review.submitListingReview({
          listingAlias,
          rating,
          comment,
          reviewType,
        }),
      )
        .then(() => {
          dispatch({ type: constants.SUBMIT_REVIEW_SUCCESS });
        })
        .catch(() => {
          dispatch({
            type: constants.SUBMIT_REVIEW_FAILURE,
            payload: 'Your review could not be saved. Please try again.',
          });
        });
    };
  },
  resetReview() {
    return { type: constants.SUBMIT_REVIEW_RESET };
  },
};

export default ReviewActions;
